module.exports = __webpack_public_path__ + "img/top_title_parts5.ad382aef.png";